var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterWithPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_486_26)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6 0.59997C16.6 0.268599 16.3314 -3.05176e-05 16 -3.05176e-05C15.6686 -3.05176e-05 15.4 0.268599 15.4 0.59997V3.00004H13C12.6686 3.00004 12.4 3.26867 12.4 3.60004C12.4 3.93141 12.6686 4.20004 13 4.20004H15.4V6.59999C15.4 6.93136 15.6686 7.19999 16 7.19999C16.3314 7.19999 16.6 6.93136 16.6 6.59999V4.20004H19C19.3314 4.20004 19.6 3.93141 19.6 3.60004C19.6 3.26867 19.3314 3.00004 19 3.00004H16.6V0.59997ZM3.05176e-05 3.60001C3.05176e-05 3.26864 0.26866 3.00001 0.600031 3.00001H9.40003C9.7314 3.00001 10 3.26864 10 3.60001C10 3.93138 9.7314 4.20001 9.40003 4.20001H0.600031C0.26866 4.20001 3.05176e-05 3.93138 3.05176e-05 3.60001ZM3.4 9.60001C3.4 9.26864 3.66863 9.00001 4 9.00001H12.4C12.7314 9.00001 13 9.26864 13 9.60001C13 9.93138 12.7314 10.2 12.4 10.2H4C3.66863 10.2 3.4 9.93138 3.4 9.60001ZM7.60001 14.8C7.26864 14.8 7.00001 15.0686 7.00001 15.4C7.00001 15.7314 7.26864 16 7.60001 16H12.4C12.7314 16 13 15.7314 13 15.4C13 15.0686 12.7314 14.8 12.4 14.8H7.60001Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_486_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterWithPlus);
export default __webpack_public_path__ + "static/media/filter-with-plus.4afec525722ac56e01e64994a83859b0.svg";
export { ForwardRef as ReactComponent };